import type { RouteRecordRaw } from 'vue-router';

export const MOVEMENT_ROUTER: RouteRecordRaw[] = [
  {
    path: '/movement',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/movement/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/movement/movement/views/Movement.vue'),
        name: 'movement List',
        meta: {
          title: '재고 이동',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/movement/movement/views/MovementCreate.vue'),
        name: 'movement Create',
        meta: {
          title: '이동 등록',
        },
      },
    ],
  },
];
